module.exports = __webpack_public_path__ + "static/media/sun_inactive.9ae41b63.svg";